import {Component, OnInit} from '@angular/core';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-dossier-invalid',
    template: `
        <h5 mat-dialog-title>{{'front.candidature.dossierIncomplet'|translate}}</h5>
        <mat-dialog-content>
            <p class="dossier-invalid-text">
                {{'front.candidature.texteDossierIncomplet'|translate}}
            </p>
            <!--<ul>
                <li style="list-style: none">Etape valide</li>
                <li style="list-style: none">
                    <span class="pastille"></span>Etape incomplete ou avec des
                    erreurs
                </li>
                <li style="list-style: none">Etape valide</li>
            </ul>-->
        </mat-dialog-content>
        <mat-dialog-actions>
            <button  mat-raised-button  color="primary"  [mat-dialog-close]="false">Fermer</button>
        </mat-dialog-actions>
    `,
    styles: [
        `
                     .pastille {
                         height: 10px;
                         width: 10px;
                         display: inline-block;
                         background: red;
                         margin-left: -20px;
                         border-radius: 50%;
                         margin-right: 10px;
                     }

                     .dossier-invalid-text {
                         font-size: 14px;
                         line-height: 24px;
                         letter-spacing: 0;
                     }
                 `,
    ],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalDossierInvalidComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
